import { Content } from "pdfmake/interfaces";
import { date, il, set } from "report/common/icon";
import layout from "report/common/layout";
import getTitle from "report/common/title";
import appliedFilter from "./applied-filter";

const withWrapHintsForLongAsciiTokens = (value: string): string => {
  return value.replace(/[A-Za-z0-9._\/-]{20,}/g, (token) =>
    token.replace(/(.{12})/g, "$1 ")
  );
};

const get = (
  t: any,
  lineName: string,
  lineLength: string,
  projectType: string,
  locationsFilterInfo: any[]
): Content[] => {
  const parts: Content[] = [
    getTitle(t("report.Report Details")),
    {
      table: {
        headerRows: 0,
        widths: [13, 83, "*"],
        body: [
          [
            {
              image: set,
              width: 7.5,
              alignment: "right",
              marginTop: 3
            },
            { text: t("report.Line Name"), opacity: 0.6 },
            {
              text: withWrapHintsForLongAsciiTokens(lineName),
              noWrap: false
            }
          ],
          [
            {
              image: il,
              width: 7.5,
              alignment: "right",
              marginTop: 3
            },
            { text: t("drawShape.length"), opacity: 0.6 },
            lineLength
          ],
          [
            {
              image: il,
              width: 7.5,
              alignment: "right",
              marginTop: 3
            },
            { text: t("drawShape.projectType"), opacity: 0.6 },
            projectType
          ],
          [
            {
              image: date,
              width: 7.5,
              alignment: "right",
              marginTop: 3
            },
            { text: t("report.date"), opacity: 0.6 },
            new Date().toLocaleString()
          ]
        ]
      },
      layout: layout(),
      fontSize: 8
    }
  ];

  const af = appliedFilter(t, locationsFilterInfo); // Content | undefined
  if (af) parts.push(af);

  return parts;
};

export default get;
